let speedData = {
    labels: [],
    datasets: [{
        label: 'speed (km/h)',
        borderColor: 'rgba(75, 192, 192, 1)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderWidth: 1,
        data: [],
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        tension: 0.4,
    }],
};

let speedChart = null;

// Wait for chart.js (+ the date adapter), injected at idle by
// SpeedMeter.blade.php, to finish parsing before constructing the chart. The
// 255 KB chart bundle is deliberately kept OUT of the first-interaction window
// — it is the #speedometer INP bottleneck: it now loads at idle / on load / on
// the tracking toggle, never on a random first tap or scroll (the old loader
// fired on pointerdown/touchstart/scroll and dropped its parse straight into
// the gauge-tap window). This guard removes any race between the user starting
// to track and chart.js finishing parse, so the chart always renders while the
// heavy parse stays off the interaction critical path.
function whenChartReady(cb) {
    if (typeof window.Chart === 'function') { cb(); return; }
    var tries = 0;
    var id = window.setInterval(function () {
        var ready = typeof window.Chart === 'function';
        if (ready || ++tries > 120) {            // poll 50ms x 120 ~= 6s max
            window.clearInterval(id);
            if (ready) cb();
        }
    }, 50);
}

const drawChart = () => {

    document.querySelector("#speedChart").style.display = "block";

    whenChartReady(function () {
        initSpeedChart();

        // 2000ms (was 1000): the Chart.js redraw in updateSpeedChart is a heavy
        // periodic main-thread task during tracking and contends with taps on the
        // gauge (attributed as #speedometer INP). Half as many updates = less
        // contention; ~3 min of history still shown (MAX_POINTS below).
        setInterval(function () { if (!document.hidden) updateSpeedChart(); }, 2000);
    });

}

const initSpeedChart = () => {

    const maxTicksLimit = window.innerWidth < 768 ? 3 : 6;

    speedChart = new Chart(document.getElementById('speedChart').getContext('2d'), {
        type: 'line',
        data: speedData,
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    type: 'time',
                    time: {
                        unit: "second",
                        tooltipFormat: "HH:mm:ss",
                        displayFormats: {
                            second: "HH:mm:ss",
                        },
                    },
                    ticks: {
                        maxTicksLimit: maxTicksLimit,
                        autoSkip: true,
                        maxRotation: 0,
                        minRotation: 0,
                    },
                    title: {
                        display: true,
                        text: 'time',
                    },
                    grid: {
                        display: true,
                        color: "rgba(200, 200, 200, 0.3)",
                        lineWidth: 1,
                    },
                },
                y: {
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: 'speed (km/h)',
                    },
                    ticks: {
                        beginAtZero: false,
                    },
                    grid: {
                        display: true,
                        color: "rgba(200, 200, 200, 0.3)",
                        lineWidth: 1,
                    },
                },
            },
            elements: {
                point: {
                    radius: 0,
                },
                line: {
                    tension: 0.4,
                },
            },
        },
    });

}

const MAX_POINTS = 90;
const updateSpeedChart = () => {
    if (!speedChart) return;
    const now = new Date();
    speedData.datasets[0].data.push(window.currentSpeed || 0);
    speedData.labels.push(now);
    // Cap the series so each Chart.js update stays O(MAX_POINTS). An unbounded
    // history makes every update progressively more expensive -> INP on mobile.
    if (speedData.datasets[0].data.length > MAX_POINTS) {
        speedData.datasets[0].data.shift();
        speedData.labels.shift();
    }
    speedChart.update('none');
}

window.drawChart = drawChart;

